import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_PAC_NOTES_REQUEST: '',
  GET_PAC_NOTES_SUCCESS: '',
  GET_PAC_NOTES_FAILURE: '',

  GET_PAC_INFO_FOR_CARE_PLAN_PAGE_REQUEST: '',
  GET_PAC_INFO_FOR_CARE_PLAN_PAGE_SUCCESS: '',
  GET_PAC_INFO_FOR_CARE_PLAN_PAGE_FAILURE: '',

  GET_UNREAD_PAC_TYPE_COUNT_REQUEST: '',
  GET_UNREAD_PAC_TYPE_COUNT_SUCCESS: '',
  GET_UNREAD_PAC_TYPE_COUNT_FAILURE: '',

  GET_PAC_NOTE_LOGS_REQUEST: '',
  GET_PAC_NOTE_LOGS_SUCCESS: '',
  GET_PAC_NOTE_LOGS_FAILURE: '',

  GET_PAC_STATUS_REQUEST: '',
  GET_PAC_STATUS_SUCCESS: '',
  GET_PAC_STATUS_FAILURE: '',

  GET_PAC_PLANS_REQUEST: '',
  GET_PAC_PLANS_SUCCESS: '',
  GET_PAC_PLANS_FAILURE: '',

  GET_PAC_DETAIL_PLAN_REQUEST: '',
  GET_PAC_DETAIL_PLAN_SUCCESS: '',
  GET_PAC_DETAIL_PLAN_FAILURE: '',

  GET_PAC_MED_DETAIL_REQUEST: '',
  GET_PAC_MED_DETAIL_SUCCESS: '',
  GET_PAC_MED_DETAIL_FAILURE: '',

  GET_PAC_PLAN_LOGS_REQUEST: '',
  GET_PAC_PLAN_LOGS_SUCCESS: '',
  GET_PAC_PLAN_LOGS_FAILURE: '',

  UPDATE_PAC_READ_INFO_REQUEST: '',
  UPDATE_PAC_READ_INFO_SUCCESS: '',
  UPDATE_PAC_READ_INFO_FAILURE: '',

  SAVE_PAC_NOTE_REQUEST: '',
  SAVE_PAC_NOTE_SUCCESS: '',
  SAVE_PAC_NOTE_FAILURE: '',

  SAVE_PAC_PLAN_REQUEST: '',
  SAVE_PAC_PLAN_SUCCESS: '',
  SAVE_PAC_PLAN_FAILURE: '',

};

types = setStoreTypeValues(types, 'eligibilityPAC');

export default types;
